import { Box, Theme } from '@mui/material';
import { useSelector } from 'react-redux';

import { selectPlayerProgress, selectPlayerSeekToPosition } from '@/store';
import { Chapter } from '@/types';
import { convertMsToHHMMSS } from '@/utils';

interface ProgressInfoProps {
  chapter?: Chapter;
}

export const ProgressInfo = ({ chapter }: ProgressInfoProps) => {
  const chapterDuration = chapter?.duration;
  const progress = useSelector(selectPlayerProgress);
  const seekToPosition = useSelector(selectPlayerSeekToPosition);
  const position = progress.position || seekToPosition;

  const formattedCurrentPosition = convertMsToHHMMSS(position! * 1000);
  const formattedChapterDuration = convertMsToHHMMSS(
    (chapterDuration ?? 0) * 1000,
  );

  return (
    <Box sx={styles.progress}>
      <span>
        {formattedCurrentPosition} / {formattedChapterDuration}
      </span>
    </Box>
  );
};

const styles = {
  progress: (theme: Theme) => ({
    color: 'white',
    mr: 2.5,
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      mr: 10,
    },
  }),
};
